import PrivateLayout from '@/layouts/PrivateLayout.vue';
import DevicesListPage from '@/pages/devices/DevicesList.vue';
import TemplatesPage from '@/pages/TemplatesPage.vue';
import PhotosPage from '@/pages/PhotosPage.vue';

export default [
  {
    path: '/devices',
    component: PrivateLayout,
    children: [{ path: '', name: 'Devices', component: DevicesListPage }],
    meta: { requiresAuth: true, roles: ['superuser', 'user'] },
  },
  {
    path: '/templates',
    component: PrivateLayout,
    children: [{ path: '', name: 'Templates', component: TemplatesPage }],
    meta: { requiresAuth: true, roles: ['superuser', 'user'] },
  },
  {
    path: '/photos',
    component: PrivateLayout,
    children: [{ path: '', name: 'Photos', component: PhotosPage }],
    meta: { requiresAuth: true, roles: ['superuser', 'user'] },
  },
];
